import { render } from "./DryingPage.vue?vue&type=template&id=56f33564"
import script from "./DryingPage.vue?vue&type=script&lang=js"
export * from "./DryingPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alpha/Documents/IONS/project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__